import React, { useState, useEffect, useRef } from "react";

// material ui
//import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import useStyles from "./styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { generateYears, generateMonths } from "../../../../../utils/generator";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import InfoButton from "../../../../../components/InfoButton";

var d = new Date();
var n = d.getFullYear();
var m = d.getMonth() + 1;
const years = generateYears(n - 25);
const months = generateMonths();

function SubForm04({
  id,
  setValue,
  saveValue,
  saveValueJump,
  value,
  kb,
  handleNextSub,
  navigationMode,
  handleBackSub,
  no_kk,
  isSubmitting,
  setKB,
}) {
  // useEffect(() => {
  //   console.log("SubForm04 - useEffect triggered with kb:", kb);
  // }, [kb]);
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});
  const [dontUseContrasep, setDontUseContrasep] = useState(false);

  const [kontrasepsi, setKontrasepsi] = useState(
    value.pernah_menggunakan_kontrasepsi || ""
  );
  const [bulanMulai, setBulanMulai] = useState(value.bulan_mulai || "");
  const [tahunMulai, setTahunMulai] = useState(value.tahun_mulai || "");
  const [bulanBerhenti, setBulanBerhenti] = useState(
    value.bulan_berhenti || ""
  );
  const [tahunBerhenti, setTahunBerhenti] = useState(
    value.tahun_berhenti || ""
  );
  const [optBulanMulai, setOptBulanMulai] = useState(months);
  const [optTahunBerhenti, setOptTahunBerhenti] = useState();
  const [optBulanBerhenti, setOptBulanBerhenti] = useState(months);

  const pertanyaan =
    "Apa dalam 12 bulan terakhir, Ibu atau Suami pernah menggunakan alat/obat/cara kontrasepsi?";

  useEffect(() => {
    let Jawaban_D1 = bulanMulai || 0;
    let Jawaban_D2 = tahunMulai || 0;
    let Jawab_D3 = bulanBerhenti || 0;
    let Jawab_D4 = tahunBerhenti || 0;

    if (kontrasepsi == 2) {
      Jawaban_D1 = 0;
      Jawaban_D2 = 0;
      Jawab_D3 = 0;
      Jawab_D4 = 0;
    }

    let normalizeValue = {
      _id: `${no_kk}${id}`,
      Pertanyaan: pertanyaan,
      Jawaban_H1: 0,
      Jawaban_H2: 0,
      Jawaban_HDate1: "",
      Jawaban_HDate2: "",
      No_Pertanyaan: 4,
      No_KK: no_kk,
      answer: [
        {
          _id: `${no_kk}${id}01`,
          No_Jawaban: kontrasepsi,
          Jawaban_D1,
          Jawaban_D2,
          Jawab_D3,
          Jawab_D4,
          pilihankb: 0,
          Lainnya: "",
        },
      ],
    };

    if (value._rev) {
      normalizeValue._rev = value._rev;
    }

    saveValueJump(normalizeValue);
  }, [kontrasepsi, bulanMulai, tahunMulai, bulanBerhenti, tahunBerhenti]);

  // useEffect(() => {
  //   console.log("SubForm04 - useEffect triggered with value:", value);
  // }, []);

  useEffect(() => {
    setError({});

    if (value.tahun_mulai) {
      let selisih = n - value.tahun_mulai;
      setOptTahunBerhenti(generateYears(n - selisih));
    }

    /* cek kondisi untuk semua form */
    if (
      kb["0102"].sedang_hamil === "2" &&
      kb["0103"].menggunakan_kontrasepsi === "2" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "1"
    ) {
      setDontUseContrasep(true);
    } else {
      if (
        kb["0102"].sedang_hamil === "2" &&
        kb["0103"].menggunakan_kontrasepsi === "1"
      ) {
        let normalizeValue = {};

        setKB({
          ...kb,
          [id]: {
            ...kb[id],
            ["pernah_menggunakan_kontrasepsi"]: undefined,
          },
        });

        if (navigationMode === "back") {
          handleBackSub();
        } else {
          saveValueJump(normalizeValue);
          handleNextSub();
        }
      } else {
        setDontUseContrasep(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //     if(tahunBerhenti === n){
  //         setOptBulanBerhenti(months.slice(0,m))
  //     } else if(tahunBerhenti === n-1){
  //         setOptBulanBerhenti(months.slice(m-1,months.length))
  //     }

  //     if(value.tahun_mulai === n){
  //         setOptTahunBerhenti(generateYears(n))
  //     }else{
  //         setOptTahunBerhenti(generateYears(n - 1))
  //     }

  // },[tahunBerhenti])

  // useEffect(() => {
  //   if (optBulanBerhenti.includes(value.bulan_berhenti)) {
  //     console.log(
  //       optBulanBerhenti.includes(value.bulan_berhenti),
  //       "bulan.includes(value.bulan_berhenti)"
  //     );
  //   } else {
  //     value.bulan_berhenti = null;
  //   }
  // }, [optBulanBerhenti]);

  if (!dontUseContrasep) {
    return null;
  }

  const handleChange = (e) => {
    if (e.target.name === "pernah_menggunakan_kontrasepsi") {
      value.bulan_mulai = null;
      setBulanMulai(null);
      value.tahun_mulai = null;
      setTahunMulai(null);
      value.bulan_berhenti = null;
      setBulanBerhenti(null);
      value.tahun_berhenti = null;
      setTahunBerhenti(null);
    }

    setValue(e);

    if (
      (value.tahun_mulai === n && e.target.name !== "tahun_mulai") ||
      (e.target.name === "tahun_mulai" && n === +e.target.value)
    ) {
      setOptTahunBerhenti(generateYears(n));
      setOptBulanMulai(months.filter((month) => month <= m));

      if (e.target.name === "bulan_mulai") {
        setOptBulanBerhenti(months.filter((month) => month > e.target.value));
      } else if (e.target.name !== "bulan_mulai" && value.bulan_mulai) {
        setOptBulanBerhenti(
          months.filter((month) => month > value.bulan_mulai)
        );
      } else {
        setOptBulanBerhenti(months);
      }
    } else {
      setOptTahunBerhenti(generateYears(n - 1));
      setOptBulanMulai(months);
    }

    setError({
      ...error,
      [e.target.name]: "",
    });

    switch (e.target.name) {
      case "pernah_menggunakan_kontrasepsi":
        setKontrasepsi(e.target.value);
        break;
      case "bulan_mulai":
        setBulanMulai(e.target.value);
        break;
      case "tahun_mulai":
        setTahunMulai(e.target.value);
        let selisih = n - e.target.value;
        // setTahun(generateYears(n - selisih))
        // setTahun(generateYears(n - 1))
        break;
      case "bulan_berhenti":
        setBulanBerhenti(e.target.value);
        break;
      case "tahun_berhenti":
        setTahunBerhenti(e.target.value);
        break;
      default:
        break;
    }

    // setSomethingChange(true)
  };

  const validate = () => {
    let newError = {};

    if (!value.pernah_menggunakan_kontrasepsi) {
      newError.pernah_menggunakan_kontrasepsi = "Wajib diisi";
    }

    if (value.pernah_menggunakan_kontrasepsi === "1") {
      if (!value.bulan_mulai) {
        newError.bulan_mulai = "Bulan mulai wajib diisi";
      }

      if (!value.tahun_mulai) {
        newError.tahun_mulai = "Tahun mulai wajib diisi";
      }

      if (
        !value.bulan_berhenti ||
        value.bulan_berhenti === null ||
        value.bulan_berhenti === ""
      ) {
        newError.bulan_berhenti = "Bulan berhenti wajib diisi";
      }

      if (!value.tahun_berhenti) {
        newError.tahun_berhenti = "Tahun berhenti wajib diisi";
      }

      if (value.tahun_berhenti < value.tahun_mulai) {
        newError.tahun_berhenti =
          "Tahun berhenti tidak boleh lebih kecil dari tahun mulai";
      }

      if (value.tahun_berhenti == value.tahun_mulai) {
        if (value.bulan_berhenti < value.bulan_mulai) {
          newError.bulan_berhenti =
            "Bulan berhenti tidak boleh lebih kecil dari bulan mulai";
        }
      }

      if (value.tahun_berhenti === new Date().getFullYear()) {
        if (value.bulan_berhenti > new Date().getMonth() + 1) {
          newError.bulan_berhenti =
            "Bulan berhenti tidak boleh lebih dari bulan dan tahun saat ini";
        }
      }
    }

    return newError;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const findErrors = validate();

    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      let Jawaban_D1 = value.bulan_mulai || 0;
      let Jawaban_D2 = value.tahun_mulai || 0;
      let Jawab_D3 = value.bulan_berhenti || 0;
      let Jawab_D4 = value.tahun_berhenti || 0;

      let normalizeValue = {
        _id: `${no_kk}${id}`,
        Pertanyaan: pertanyaan,
        Jawaban_H1: 0,
        Jawaban_H2: 0,
        Jawaban_HDate1: "",
        Jawaban_HDate2: "",
        No_Pertanyaan: 4,
        No_KK: no_kk,
        answer: [
          {
            _id: `${no_kk}${id}01`,
            No_Jawaban: value.pernah_menggunakan_kontrasepsi,
            Jawaban_D1,
            Jawaban_D2,
            Jawab_D3,
            Jawab_D4,
            pilihankb: 0,
            Lainnya: "",
          },
        ],
      };

      if (value._rev) {
        normalizeValue._rev = value._rev;
      }

      saveValue(normalizeValue);
      // console.log("NORMALIZE VALUE KB N0.5 >>>>> ", normalizeValue)
    }
  };

  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>04</span>Apa dalam 12 bulan
              terakhir, Ibu atau Suami <strong>pernah</strong> menggunakan
              alat/obat/cara kontrasepsi?
            </Typography>
            <div style={{ position: "absolute", right: "0", top: "58px" }}>
              <InfoButton
                content={
                  "Jika responden lupa kapan mulai dan atau kapan berhenti, kaitkan dengan peristiwa penting seperti tanggal lahir anak terakhir." +
                  "\nKapan berhenti adalah bulan dan tahun berhenti menggunakan KB dalam 12 bulan terakhir."
                }
              />
            </div>
          </div>
          <div className={classes.cardBody}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={error.pernah_menggunakan_kontrasepsi ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.pernah_menggunakan_kontrasepsi || ""}
                    onChange={handleChange}
                    aria-label="pernah_menggunakan_kontrasepsi"
                    name="pernah_menggunakan_kontrasepsi"
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="1"
                      label="1. Ya"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="2"
                      label="2. Tidak"
                    />
                  </RadioGroup>
                  <FormHelperText>
                    {error.pernah_menggunakan_kontrasepsi}
                  </FormHelperText>
                </FormControl>
              </Grid>
              {value.pernah_menggunakan_kontrasepsi === "1" && (
                <>
                  <Grid item xs={12}>
                    <Typography>
                      Kapan mulai menggunakan Alat/obat/cara kontrasepsi
                      terakhir?
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      error={error.bulan_mulai ? true : false}
                    >
                      <Select
                        id="bulan_mulai"
                        value={value.bulan_mulai || ""}
                        onChange={handleChange}
                        name="bulan_mulai"
                        displayEmpty
                      >
                        <MenuItem value="">Bulan</MenuItem>
                        {optBulanMulai.map((month) => (
                          <MenuItem key={month} value={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{error.bulan_mulai}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      error={error.tahun_mulai ? true : false}
                    >
                      <Select
                        id="tahun_mulai"
                        value={value.tahun_mulai || ""}
                        onChange={handleChange}
                        name="tahun_mulai"
                        displayEmpty
                      >
                        <MenuItem value="">Tahun</MenuItem>
                        {years.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{error.tahun_mulai}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>
                      Kapan berhenti menggunakan Alat/obat/cara kontrasepsi
                      terakhir?
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      error={error.bulan_berhenti ? true : false}
                    >
                      <Select
                        id="bulan_berhenti"
                        value={value.bulan_berhenti || ""}
                        onChange={handleChange}
                        name="bulan_berhenti"
                        displayEmpty
                      >
                        <MenuItem value="">Bulan</MenuItem>
                        {optBulanBerhenti.map((month) => (
                          <MenuItem key={month} value={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{error.bulan_berhenti}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      error={error.tahun_berhenti ? true : false}
                    >
                      <Select
                        id="tahun_berhenti"
                        value={value.tahun_berhenti || ""}
                        onChange={handleChange}
                        name="tahun_berhenti"
                        displayEmpty
                      >
                        <MenuItem value="">Tahun</MenuItem>
                        {optTahunBerhenti &&
                          optTahunBerhenti.map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>{error.tahun_berhenti}</FormHelperText>
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          Selanjutnya <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubForm04;
